import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import Buefy from 'buefy'
import VueScrollTo from 'vue-scrollto'
import 'buefy/dist/buefy.css'

export const bus = new Vue();

Vue.use(Buefy)

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.config.productionTip = false

new Vue({
  store,
  router,
  components: { App },
  render: h => h(App),
}).$mount('#root')